import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
Vue.use(VueToast);

export const myFunction = {
  showInfo: function (msg, type) {
    Vue.$toast.open({
      message: msg,
      type: type,
      duration: 10000,
      position: "top-right",
      dismissible: true,
    });
  },
};

export function formatFullName(first, middle, last) {
  const normalize = (value) => {
    if (value === null || value === undefined) return "";
    const str = String(value).trim();
    if (!str) return "";
    const lower = str.toLowerCase();
    if (lower === "null" || lower === "undefined" || lower === "na") return "";
    return str;
  };
  const parts = [normalize(first), normalize(middle), normalize(last)].filter(
    Boolean,
  );
  return parts.join(" ").trim();
}
